<button class="green_button" [style.width]="width" [style.height]="height" (click)="onClick()">
    <!-- plus icon before -->
    <i [style.color]="iconColor" [style.font-size]="iconSize" *ngIf="showPlus==true&&iconBefore==true"
        class="fa-light fa-plus  icon" [style.margin]="iconMargin" [style.margin]="iconMargin"></i>

    <!-- right icon before -->
    <i [style.color]="iconColor" [style.font-size]="iconSize" *ngIf="showArrow==true&&iconBefore==true"
        class="fa-solid fa-chevron-left icon" [style.margin]="iconMargin"></i>

    <!-- button label name -->
    <i *ngIf="iconBefore==true" [style.font-size]="iconSize" [style.color]="iconColor" class="{{iconClassName}} icon"
        [style.margin]="iconMargin"></i>

    {{ label }}

    <i *ngIf="iconBefore==false" [style.font-size]="iconSize" [style.color]="iconColor" class="{{iconClassName}} icon"
        [style.margin]="iconMargin"></i>

    <!-- right icon After -->
    <i [style.color]="iconColor" [style.font-size]="iconSize" *ngIf="showArrow==true&&iconBefore==false"
        class="fa-solid fa-chevron-right icon" [style.margin]="iconMargin"></i>

    <!-- plus icon After -->
    <i [style.color]="iconColor" [style.font-size]="iconSize" *ngIf="showPlus==true &&iconBefore==false"
        class="fa-light fa-plus icon" [style.margin]="iconMargin"></i>
</button>